import React from "react";
import { Pencil, Synchronisation } from "../../assets/icons";
import Button from "../button";
import Tooltip from "../tooltips/Tooltips";

const shellClass =
  "flex flex-col divide-y divide-gray-100 rounded-lg border border-gray-100 bg-white md:flex-row md:items-stretch md:divide-x md:divide-y-0";

const titleClass =
  "shrink-0 text-[16px] font-bold leading-normal text-gray-900";

const MissionInfoBar = ({
  id,
  isWaitingUserMission,
  userMission,
  editTempWorkerPhone,
  editTempWorkerToken,
}) => {
  if (isWaitingUserMission) {
    return (
      <div className={`${shellClass} animate-pulse`}>
        <div className="flex min-w-0 flex-1 flex-col gap-0 px-4 py-2">
          <div className={titleClass}>Mission</div>
          <div className="h-4 w-32 rounded bg-gray-200" />
        </div>

        <div className="flex min-w-0 flex-1 items-start justify-between gap-3 px-4 py-2">
          <div className="flex min-w-0 flex-1 flex-col gap-0">
            <div className={titleClass}>Code pin</div>
            <div className="h-4 w-32 rounded bg-gray-200" />
          </div>
          <div className="h-8 w-8 shrink-0 self-center rounded bg-gray-200" />
        </div>

        <div className="flex min-w-0 flex-1 items-start justify-between gap-3 px-4 py-2">
          <div className="flex min-w-0 flex-1 flex-col gap-0">
            <div className={titleClass}>Téléphone</div>
            <div className="h-4 w-32 rounded bg-gray-200" />
          </div>
          <div className="h-8 w-8 shrink-0 self-center rounded bg-gray-200" />
        </div>
      </div>
    );
  }

  return (
    <div className={shellClass}>
      <div className="flex min-w-0 flex-1 flex-col gap-0 px-4 py-2">
        <div className={titleClass}>Mission</div>
        <div className="break-all text-[14px] leading-normal text-gray-700">
          {id}
        </div>
      </div>

      <div className="flex min-w-0 flex-1 items-start justify-between gap-3 px-4 py-2">
        <div className="flex min-w-0 flex-1 flex-col gap-0">
          <div className={titleClass}>Code pin</div>
          <div className="break-all text-[14px] leading-normal text-gray-700">
            {userMission.tokenMission || "Non défini"}
          </div>
        </div>
        <div className="shrink-0 self-center">
          <Tooltip placement="top" text="Régénérer le code pin">
            <span className="inline-flex">
              <Button color="SECONDARY" size="ICON" onClick={editTempWorkerToken}>
                <Synchronisation wh={20} color="#374151" />
              </Button>
            </span>
          </Tooltip>
        </div>
      </div>

      <div className="flex min-w-0 flex-1 items-start justify-between gap-3 px-4 py-2">
        <div className="flex min-w-0 flex-1 flex-col gap-0">
          <div className={titleClass}>Téléphone</div>
          <div className="break-all text-[14px] leading-normal text-gray-700">
            {userMission.phone || "Non défini"}
          </div>
        </div>
        <div className="shrink-0 self-center">
          <Tooltip placement="top" text="Modifier">
            <span className="inline-flex">
              <Button color="SECONDARY" size="ICON" onClick={editTempWorkerPhone}>
                <Pencil wh={20} color="#374151" />
              </Button>
            </span>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default MissionInfoBar;
